export default "__VITE_ASSET__DX99nKc9__";